import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';

import './noFilteredClaims.scss';

export const NoFilteredClaims = ({ filterType }) => {
  return (
    <section className="noFilteredClaims">
      <Icon icon="inbox" />
      You have no recent {filterType} claims.
    </section>
  );
};

NoFilteredClaims.propTypes = {
  filterType: PropTypes.string
};
